import React, {Component} from 'react'
import * as go from 'gojs';
import { ReactDiagram } from 'gojs-react';


var KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);

class Diagram extends Component {

    constructor(props) {
        super(props)
        this.state = {
            nodeDataArray: [
                {"key":"P1", "category":"Process", "pos":"150 120", "text":"Process"},
                {"key":"P2", "category":"Process", "pos":"330 320", "text":"Tank"},
                {"key":"V1", "category":"Valve", "pos":"270 120", "text":"V1"},
                {"key":"P3", "category":"Process", "pos":"150 420", "text":"Pump"},
                {"key":"V2", "category":"Valve", "pos":"150 280", "text":"VM", "angle":270},
                {"key":"V3", "category":"Valve", "pos":"270 420", "text":"V2", "angle":180},
                {"key":"P4", "category":"Process", "pos":"450 140", "text":"Reserve Tank"},
                {"key":"V4", "category":"Valve", "pos":"390 60", "text":"VA"},
                {"key":"V5", "category":"Valve", "pos":"450 260", "text":"VB", "angle":90}
            ],
            linkDataArray: [
                {"from":"P1", "to":"V1"},
                {"from":"P3", "to":"V2"},
                {"from":"V2", "to":"P1"},
                {"from":"P2", "to":"V3"},
                {"from":"V3", "to":"P3"},
                {"from":"V1", "to":"V4"},
                {"from":"V4", "to":"P4"},
                {"from":"V1", "to":"P2"},
                {"from":"P4", "to":"V5"},
                {"from":"V5", "to":"P2"}
            ]
        }
    }

    initDiagram = () => {
        const $ = go.GraphObject.make;
        go.Diagram.licenseKey = "123123123123"
        
        go.Shape.defineFigureGenerator("Cylinder1", function(shape, w, h) {
            var param1 = shape ? shape.parameter1 : NaN;  // half the height of the ellipse
            if (isNaN(param1)) param1 = 5; // default value
            param1 = Math.min(param1, h / 3);
        
            var geo = new go.Geometry();
            var cpxOffset = KAPPA * .5;
            var fig = new go.PathFigure(0, param1, true);
            geo.add(fig);
            // The base (top)
            fig.add(new go.PathSegment(go.PathSegment.Bezier, .5 * w, 0, 0, KAPPA * param1,
            (.5 - cpxOffset) * w, 0));
            fig.add(new go.PathSegment(go.PathSegment.Bezier, 1.0 * w, param1, (.5 + cpxOffset) * w, 0,
            1.0 * w, KAPPA * param1));
            fig.add(new go.PathSegment(go.PathSegment.Line, w, h - param1));
            // Bottom curve
            fig.add(new go.PathSegment(go.PathSegment.Bezier, .5 * w, 1.0 * h, 1.0 * w, h - KAPPA * param1,
            (.5 + cpxOffset) * w, 1.0 * h));
            fig.add(new go.PathSegment(go.PathSegment.Bezier, 0, h - param1, (.5 - cpxOffset) * w, 1.0 * h,
            0, h - KAPPA * param1));
            fig.add(new go.PathSegment(go.PathSegment.Line, 0, param1));
        
            var fig2 = new go.PathFigure(w, param1, false);
            geo.add(fig2);
            fig2.add(new go.PathSegment(go.PathSegment.Bezier, .5 * w, 2 * param1, 1.0 * w, 2 * param1 - KAPPA * param1,
            (.5 + cpxOffset) * w, 2 * param1));
            fig2.add(new go.PathSegment(go.PathSegment.Bezier, 0, param1, (.5 - cpxOffset) * w, 2 * param1,
            0, 2 * param1 - KAPPA * param1));
        
            geo.spot1 = new go.Spot(0, 0, 0, 2 * param1);
            geo.spot2 = new go.Spot(1, 1);
            return geo;
        });

        const diagram = $(go.Diagram, {
            "grid.visible": true,
            "grid.gridCellSize": new go.Size(30, 20),
            "draggingTool.isGridSnapEnabled": true,
            "resizingTool.isGridSnapEnabled": true,
            "rotatingTool.snapAngleMultiple": 90,
            "rotatingTool.snapAngleEpsilon": 45,
            "undoManager.isEnabled": true,
            model: new go.GraphLinksModel({
                linkKeyProperty: 'key'  // IMPORTANT! must be defined for merges and data sync when using GraphLinksModel
            })
        });

        diagram.nodeTemplateMap.add(
            "Process",
            $(
                go.Node, "Auto",
                {
                    locationSpot: new go.Spot(0.5, 0.5), locationObjectName: "SHAPE",
                    resizable: true, resizeObjectName: "SHAPE"
                },
                new go.Binding("location", "pos", go.Point.parse).makeTwoWay(go.Point.stringify),
                $(
                    go.Shape, "Cylinder1",
                    {
                        name: "SHAPE",
                        strokeWidth: 2,
                        fill: $(go.Brush, "Linear",{
                                start: go.Spot.Left, end: go.Spot.Right,
                                0: "gray", 0.5: "white", 1: "gray"
                            }),
                        minSize: new go.Size(50, 50),
                        portId: "", fromSpot: go.Spot.AllSides, toSpot: go.Spot.AllSides
                    },
                    new go.Binding("desiredSize", "size", go.Size.parse).makeTwoWay(go.Size.stringify)
                ),
                $(
                    go.TextBlock,
                    {
                        alignment: go.Spot.Center, textAlign: "center", margin: 5,
                        editable: true
                    },
                    new go.Binding("text").makeTwoWay()
                )
            )
        )
        

        /*
        diagram.addDiagramListener("Modified", e => {
            var button = document.getElementById("SaveButton");
            if (button) button.disabled = !diagram.isModified;
            var idx = document.title.indexOf("*");
            if (diagram.isModified) {
              if (idx < 0) document.title += "*";
            } else {
              if (idx >= 0) document.title = document.title.slice(0, idx);
            }
        });
        */
        
        diagram.nodeTemplateMap.add(
            "Valve",
            $(
                go.Node, "Vertical",
                {
                    locationSpot: new go.Spot(0.5, 1, 0, -21), locationObjectName: "SHAPE",
                    selectionObjectName: "SHAPE", rotatable: true
                },
                new go.Binding("angle").makeTwoWay(),
                new go.Binding("location", "pos", go.Point.parse).makeTwoWay(go.Point.stringify),
                $(
                    go.TextBlock,
                    { alignment: go.Spot.Center, textAlign: "center", margin: 5, editable: true },
                    new go.Binding("text").makeTwoWay(),
                    // keep the text upright, even when the whole node has been rotated upside down
                    new go.Binding("angle", "angle", a => a === 180 ? 180 : 0).ofObject()
                ),
                $(
                    go.Shape,
                    {
                        name: "SHAPE",
                        geometryString: "F1 M0 0 L40 20 40 0 0 20z M20 10 L20 30 M12 30 L28 30",
                        strokeWidth: 2,
                        fill: $(go.Brush, "Linear", { 0: "gray", 0.35: "white", 0.7: "gray" }),
                        portId: "", fromSpot: new go.Spot(1, 0.35), toSpot: new go.Spot(0, 0.35)
                    }
                )
            )
        );
        
        diagram.linkTemplate = $(
            go.Link,
            { routing: go.Link.AvoidsNodes, curve: go.Link.JumpGap, corner: 10, reshapable: true, toShortLength: 7 },
            new go.Binding("points").makeTwoWay(),
            // mark each Shape to get the link geometry with isPanelMain: true
            $(go.Shape, { isPanelMain: true, stroke: "black", strokeWidth: 7 }),
            $(go.Shape, { isPanelMain: true, stroke: "gray", strokeWidth: 5 }),
            $(go.Shape, { isPanelMain: true, stroke: "white", strokeWidth: 3, name: "PIPE", strokeDashArray: [10, 10] }),
            $(go.Shape, { toArrow: "Triangle", scale: 1.3, fill: "gray", stroke: null })
        );

        diagram.model = go.Model.fromJson(`{
            "nodeDataArray": ${JSON.stringify(this.state.nodeDataArray)},
            "linkDataArray": ${JSON.stringify(this.state.linkDataArray)}
        }`);

        var animation = new go.Animation();
        animation.easing = go.Animation.EaseLinear;
        diagram.links.each(link => {
            animation.add(link.findObject("PIPE"), "strokeDashOffset", 20, 0);
        });
        // Run indefinitely
        animation.runCount = Infinity;
        animation.start();
        return diagram;
    }

    handleModelChange = (changes) => {
        console.log('GoJS model changed!');
    }
      

    render() {

        return (
            <>
            <div>
                ...
                <ReactDiagram
                    initDiagram={this.initDiagram}
                    divClassName='diagram-component'
                    nodeDataArray={this.state.nodeDataArray}
                    linkDataArray={this.state.linkDataArray}
                    onModelChange={(e) => this.handleModelChange(e)}
                />
                ...
            </div>
            <style jsx>{`
                .diagram-component {
                    width: 1200px;
                    height: 700px;
                    border: solid 1px black;
                    background-color: white;
                }
            `}</style>
            </>
        )
    }
}

export default Diagram
